import * as Sentry from '@sentry/react'
import dayjs from 'dayjs'

import { ApplicationWorkflowRequest, ApplicationWorkflowFormEntity } from 'src/types'
import { ApplicationType } from 'src/types/generated'

type ToRequestInput = {
  workflowId: number
  projectId: string
  targetRoomIds: string[]
  formEntity: ApplicationWorkflowFormEntity
  workflowType: 'publish' | 'order'
}

export const ApplicationWorkflowTranslator = {
  toRequest: (input: ToRequestInput): ApplicationWorkflowRequest => {
    const { workflowId, projectId, formEntity, targetRoomIds, workflowType } = input

    const notifiedUserEmails =
      formEntity.notification && formEntity.notification !== ''
        ? formEntity.notification
            ?.split(',')
            .map(email => email.trim())
            .filter(email => email !== '')
        : []

    return {
      workflowId,
      projectId,
      title: formEntity.title,
      notifiedUserEmails,
      comment: formEntity.comment,
      applicationSteps: formEntity.steps
        .filter(step => {
          if (!step.dueDate) {
            Sentry.captureMessage(
              `formの制御が正しく出来ておらず、申請stepの期限が設定出来ていません`
            )
          }
          return !!step.dueDate
        })
        .map(step => {
          return {
            stepNumber: step.number,
            confirmations: step.approvers
              .filter(approver => {
                if (!approver.userId) {
                  Sentry.captureMessage(
                    `formの制御が正しく出来ておらず、申請stepの承認者が設定出来ていません`
                  )
                }
                return !!approver.userId
              })
              .map(approver => {
                return {
                  confirmerId: approver.userId as number,
                }
              }),
            dueDate: dayjs(step.dueDate as Date).format('YYYY-MM-DD'),
          }
        }),
      roomIds: targetRoomIds.map(Number),
      type: workflowType === 'publish' ? ApplicationType.Publish : ApplicationType.Order,
    }
  },
}
